import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesTicketInitiator = ({data, timePeriodFilter}) => {
  return (
       <SupportServicesTable data={data} timePeriodFilter={timePeriodFilter} type="initiator" />
  );
};

export default SupportServicesTicketInitiator;
